<header class="mt-3" nz-row [nzGutter]="24">
  <nz-card
    nz-col
    [nzXs]="24"
    [nzLg]="16"
    style="cursor: pointer"
    (click)="shouldGenerateOtherImagesBasedOnLogo = !shouldGenerateOtherImagesBasedOnLogo">
    <div class="automatic-image-generation">
      <main>
        <span>Geração automática de imagens</span>

        <small nz-typography nzType="secondary" *ngIf="shouldGenerateOtherImagesBasedOnLogo">
          Com essa opção ativada, o sistema irá gerar automaticamente todas as demais imagens a partir da
          <b>logo da página de login da web</b>
          .
        </small>

        <small nz-typography nzType="secondary" *ngIf="!shouldGenerateOtherImagesBasedOnLogo">
          A geração automática de imagens está desativada. Você pode ativá-la novamente, se assim desejar.
        </small>

        <small nz-typography nzType="secondary">
          Imagens que apresentarem um
          <nz-badge nzDot>
            <small nz-typography nzType="secondary">ponto vermelho</small>
          </nz-badge>
          não serão geradas automaticamente.
        </small>
      </main>

      <nz-switch
        [(ngModel)]="shouldGenerateOtherImagesBasedOnLogo"
        [nzCheckedChildren]="checkedTemplate"
        [nzUnCheckedChildren]="unCheckedTemplate"
        (click)="$event.stopPropagation()"></nz-switch>
      <ng-template #checkedTemplate><i nz-icon nzType="check"></i></ng-template>
      <ng-template #unCheckedTemplate><i nz-icon nzType="close"></i></ng-template>
    </div>
  </nz-card>

  <aside nz-col [nzXs]="24" [nzLg]="8">
    <button nz-button nzBlock (click)="handleDownloadImages()">
      <i nz-icon nzType="download"></i>
      Baixar todas as imagens
    </button>

    <button nz-button nzBlock [nzDanger]="true" class="mt-2" (click)="handleRemoveAllImages()">
      <i nz-icon nzType="delete"></i>
      Remover todas as imagens
    </button>
  </aside>
</header>

<form nz-form [formGroup]="form">
  <ng-container *ngFor="let fieldSection of fieldsSections | keyvalue: unsortedKeyValue; let first = first">
    <nz-divider nzPlain *ngIf="!first"></nz-divider>

    <section [class.mt-3]="first">
      <header class="field-section-header">
        <nz-page-header-title>{{ fieldSection.value.title }}</nz-page-header-title>
        <nz-page-header-subtitle>{{ fieldSection.value.subtitle }}</nz-page-header-subtitle>
      </header>

      <main nz-row [nzGutter]="24">
        <ng-container *ngFor="let field of fields | keyvalue: unsortedKeyValue">
          <article nz-col [nzXs]="24" [nzMd]="12" [nzLg]="8" [nzXl]="6" [nzXXl]="4" *ngIf="field.value.section === fieldSection.key">
            <ng-container
              *ngTemplateOutlet="
                imageFormItem;
                context: { fieldKey: field.key, field: fields[field.key], formControl: form.get(field.key) }
              "></ng-container>
          </article>
        </ng-container>
      </main>
    </section>
  </ng-container>
</form>

<ng-template #imageFormItem let-fieldKey="fieldKey" let-field="field" let-formControl="formControl">
  <nz-form-item class="image-form-item">
    <nz-form-label [nzSpan]="24">
      <nz-badge nzDot [nzShowDot]="!field.autoGenerateImage">
        <span>{{ field.label }}</span>
      </nz-badge>
    </nz-form-label>

    <nz-form-control nzHasFeedback [nzSpan]="24">
      <nz-card
        style="width: 100%"
        [nzCover]="coverTemplate"
        [nzActions]="[actionChangeImage, actionCropImage, actionUndoChangesToImage, actionDownloadImage, actionRemoveImage]"></nz-card>

      <ng-template #coverTemplate>
        <img
          nz-image
          [nzSrc]="formControl.value || field.awsBucketImagePath"
          nzFallback="assets/img/image-placeholder.png"
          class="image-preview" />
      </ng-template>

      <ng-template #actionChangeImage>
        <button nz-button nzType="text" (click)="handlePickImage(fieldKey)" style="width: 100%" nz-tooltip="Alterar imagem">
          <i nz-icon nzType="upload"></i>
        </button>
      </ng-template>

      <ng-template #actionUndoChangesToImage>
        <button
          nz-button
          nzType="text"
          style="width: 100%"
          [disabled]="!field.isCropped"
          nz-tooltip="Desfazer alterações"
          (click)="undoImageChanges(fieldKey)">
          <i nz-icon nzType="undo"></i>
        </button>
      </ng-template>

      <ng-template #actionCropImage>
        <button nz-button nzType="text" style="width: 100%" nz-tooltip="Recortar imagem" (click)="showModalImageCropper(fieldKey)">
          <i nz-icon nzType="expand"></i>
        </button>
      </ng-template>

      <ng-template #actionDownloadImage>
        <button nz-button nzType="text" (click)="handleDownloadImage(fieldKey)" style="width: 100%" nz-tooltip="Baixar imagem">
          <i nz-icon nzType="download"></i>
        </button>
      </ng-template>

      <ng-template #actionRemoveImage>
        <button
          nz-button
          nzType="text"
          [nzDanger]="true"
          (click)="handleRemoveImage(fieldKey)"
          style="width: 100%"
          nz-tooltip="Remover imagem">
          <i nz-icon nzType="delete"></i>
        </button>
      </ng-template>
      <!--      </ng-container>-->

      <ng-container *ngIf="formControl.invalid && formControl.touched">
        <small
          nz-typography
          nzType="danger"
          class="mt-1"
          style="display: block; line-height: 1.25"
          *ngFor="let error of formControl.errors | keyvalue">
          <ng-container *ngIf="error.key === 'required'">{{ field.label }} é obrigatório(a).</ng-container>

          <ng-container *ngIf="error.key === 'invalidImageSize'">
            O tamanho máximo para o(a)
            <b>{{ field.label }}</b>
            é de
            <b>{{ field.imageConfig.container.width }} x {{ field.imageConfig.container.height }}px</b>
            .
          </ng-container>
        </small>
      </ng-container>

      <small
        nz-typography
        nzType="secondary"
        [innerHTML]="field.helpText"
        *ngIf="field.helpText"
        class="mt-1"
        style="display: block; line-height: 1.25"></small>
    </nz-form-control>
  </nz-form-item>
</ng-template>
